module.exports = __webpack_public_path__ + "img/city_box2.628da3af.png";